import React, { useEffect, useRef, useState } from 'react'
import { useAuthStore } from '../../AuthStore/AuthStore';
import { API } from '../../Axios/Axios';
import { empFormData, getFormData } from '../../Helpers/APIEndpoints/Endpoints';
import { usePDF } from 'react-to-pdf';
//import html2pdf from 'html2pdf.js';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';


const Form12bb = () => {
    
    const[empName, setEmpName] = useState<any>();
    const[panNo, setPanNo] = useState<any>();
    const[mobNo, setMobNo] = useState<any>();
    const[financialYear, setFinancialYear] = useState<any>();
    const[fatherName, setFatherName] = useState<any>()
    const[address, setAddress] = useState<any>()
    const[place, setPlace] = useState<any>();
    const [designation, setDesignation] = useState<any>();
    const{currentFinancialYearId,userId}= useAuthStore();
    const [formData, setFormData] = useState<any>([])
    //const { toPDF, targetRef } = usePDF({filename: 'Form12B.pdf'});
    const targetRef = useRef<HTMLDivElement>(null);
    const [isChecked, setIsChecked] = useState(false);
    const navigate = useNavigate();





    useEffect(()=>{
        const getEmpInfo =async()=>{
            const res = await API.post(empFormData,{
                UserId : userId,
                FinancialYearId : currentFinancialYearId
            })
            console.log('form 12 bb response=>',res)
            if(res.data.data){
                setEmpName(res?.data?.data[0]?.employeeName)
                setPanNo(res?.data?.data[0]?.pan)
                setMobNo(res?.data?.data[0]?.mobileNo)
                setFinancialYear(res?.data?.data[0]?.financialCycle)
               // setFatherName(res?.data?.data[0]?.fatherName)
               // setAddress(res?.data?.data[0]?.address)

            }
        }
        getEmpInfo();
    },[userId, currentFinancialYearId])

    useEffect(()=>{
        const getform =async()=>{
            const res = await API.post(getFormData,{
                UserId : userId,
                FinancialYearId : currentFinancialYearId
            })
            console.log('form 12 form data response=>',res)
            if(res.data.data){
                setFormData(res?.data?.data);
            }
        }
        getform();
    },[userId,currentFinancialYearId])
    console.log('form data========>',formData);
    // const handleSubmit = (e: React.MouseEvent<HTMLInputElement>) => {
    //     e.preventDefault();
      
    //     if (targetRef.current) {
    //       // Clone the content of the ref
    //       const clone = targetRef.current.cloneNode(true) as HTMLElement;
      
    //       // Remove any element with class "no-print"
    //       const elementsToRemove = clone.querySelectorAll('.no-print');
    //       elementsToRemove.forEach(el => el.remove());
      
    //       // Get the final cleaned HTML (optional, if you want to store it)
    //       const finalHtml = clone.innerHTML;
    //       setCleanedHtml(finalHtml); // if you want to store for later
      
    //       // Pass clone to PDF generator
    //       generatePDF(clone);
    //     }
    //   };
    //   const generatePDF = (element: HTMLElement) => {
    //     import('html2pdf.js').then((html2pdf) => {
    //       html2pdf.default()
    //         .from(element)
    //         .set({
    //           margin: 10,
    //           filename: 'form-12bb.pdf',
    //           html2canvas: { scale: 2 },
    //           jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    //         })
    //         .save();
    //     });
    //   };
    // const generatePDF = async () => {
    //     if (targetRef.current) {
    //       // Clone the element
    //       const clone = targetRef.current.cloneNode(true) as HTMLElement;
    
    //       // Remove elements with class "no-print"
    //       clone.querySelectorAll('.no-print').forEach(el => el.remove());
    
    //       // Create a hidden container to render clean version
    //       const hiddenDiv = document.createElement('div');
    //       hiddenDiv.style.position = 'absolute';
    //       hiddenDiv.style.left = '-9999px';
    //       hiddenDiv.appendChild(clone);
    //       document.body.appendChild(hiddenDiv);
    
    //       const canvas = await html2canvas(clone);
    //       const imgData = canvas.toDataURL('image/png');
    
    //       const pdf = new jsPDF('p', 'mm', 'a4');
    //       const pdfWidth = pdf.internal.pageSize.getWidth();
    //       const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    
    //       pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    //       pdf.save('form-12bb.pdf');
    
    //       document.body.removeChild(hiddenDiv);
    //     }
    //   };
    const generatePDF = async () => {

        if (!designation || !fatherName || !address || !place) {
            message.error('Please fill in all required fields.');
            return false;
            }

        if (!isChecked) {
         // alert('Please check the declaration checkbox before downloading PDF.');
          message.error('Please check the declaration checkbox before downloading PDF.');
          return;
        }
    
        if (!targetRef.current) {
          message.error('PDF content is not ready.');
          return;
        }
    
        
        const clone = targetRef.current.cloneNode(true) as HTMLElement;
        clone.querySelectorAll('.no-print').forEach(el => el.remove());
    
     
        const container = document.createElement('div');
        container.style.position = 'absolute';
        container.style.top = '-9999px';
        container.appendChild(clone);
        document.body.appendChild(container);
    
        try {
        //   const canvas = await html2canvas(clone, { scale: 2 });
        //   const imgData = canvas.toDataURL('image/png');
          const canvas = await html2canvas(clone, { scale: 2 }); 
          const imgData = canvas.toDataURL('image/jpeg', 1);
          const pdf = new jsPDF('p', 'mm', 'a4');
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    
         // pdf.addImage(imgData, 'PNG', 10, 10, pdfWidth - 20, pdfHeight);
         pdf.addImage(imgData, 'JPEG', 5, 5, pdfWidth - 10, pdfHeight - 10);
          pdf.save('form-12bb.pdf');
          navigate("/EmployeeTabs")
        } catch (error) {
          console.error('PDF generation error:', error);
          message.error('Something went wrong while generating the PDF.');
        }
    
        document.body.removeChild(container);
    };
    //   const handleGeneratePDF = () => {
    //     if (!isChecked) {
    //       alert("Please confirm the declaration by checking the box.");
    //       return;
    //     }
      
    //     generatePDF(targetRef.current); // Call your PDF logic here
    //   };
      
  return (
    <>
        
        <html>
        <div ref={targetRef} >
            <head>
                <title>Form 12BB</title>
            </head>
            <body>
                <div style={{ width: '100%', marginBottom: '20px' }}>
                    <h3 style={{ borderBottom: '1px solid #8FA5CD', width: '20%', margin: '0 auto', textAlign: 'center' }}>Form No. 12BB</h3>
                    <p style={{ textAlign: 'center'}}>(See Rule 26C)</p>
                    <p style={{ textAlign: 'center'}}>Statement showing particulars of claim by an employee for deduction of tax under section 192</p>

                    <div style={{ marginBottom: '10px' }}>
                        <div style={{ width: '100%', display: 'flex',   marginBottom: '10px', justifyContent: 'flex-start',alignItems: 'flex-start' }}>
                            {/* <div style={{ width: '10%' }}></div> */}

                            <div style={{ width: '40%', textAlign: 'left' }}>
                                <p style={{ margin: 0 }}><b>Name of the employee: </b>{empName}</p>
                                <p style={{ margin: 0 }}><b>Mobile No:</b> {mobNo}</p>
                            </div>

                            <div style={{ width: '40%', textAlign: 'left' }}>
                                <p style={{ margin: 0 }}><b>PAN of the Employee: </b>{panNo}</p>
                                <p style={{ margin: 0 }}><b>Financial Year:</b> {financialYear}</p>
                            </div>

                            <div style={{ width: '10%' }}></div>
                        </div>
                        <div style={{ width: '50%', margin: '0 auto' }}>
                        </div>
                    </div>
                </div>

                <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid' }}>
                    <thead style={{ textAlign: 'left', background: '#D5DBFF', borderTop: '1px solid #000', borderBottom: '1px solid #000' }}>
                        <th style={{ padding: '4px' }}>Sr No</th>
                        <th style={{ padding: '4px', width: '30%' }}>Components</th>
                        <th style={{ padding: '4px' }}>Projected Saving</th>
                        <th style={{ padding: '4px' }}>Investment Proof Submitted</th>
                        <th style={{ padding: '4px' }}>Maximum Eligible</th>
                        <th style={{ padding: '4px' }}>Eligible Amount</th>
                        <th style={{ padding: '4px' }}>Approved Amount</th>
                        <th style={{ padding: '4px' }}>No of Docs</th>
                        <th style={{ padding: '4px' }}>Reason</th>
                    </thead>
                    <tbody>
                        {formData && 
                            formData.map((obj:any,index : any)=>
                              (
                                <tr style={{ borderTop: '1px solid #000', borderBottom: '1px solid #000' }}>
                                <td style={{ padding: '4px' }}>{index + 1}</td>
                                <td style={{ padding: '4px' }}>{obj.componentName == null? obj?.sectionName : obj?.componentName}</td>
                                <td style={{ padding: '4px' }}>{obj.projectedSaving ? obj?.projectedSaving : 0}</td>
                                <td style={{ padding: '4px' }}>{obj.investmentProofSubmitted ? obj?.investmentProofSubmitted : 0}</td>
                                <td style={{ padding: '4px' }}>{obj.maximumEligible ? obj?.maximumEligible : 0}</td>
                                <td style={{ padding: '4px' }}>{obj.eligibleAmount ? obj?.eligibleAmount :0 }</td>
                                <td style={{ padding: '4px' }}>{obj.approvedAmount ? obj?.approvedAmount : 0}</td>
                                <td style={{ padding: '4px' }}>{obj.noOfDoc ? obj?.noOfDoc : 0}</td>
                                <td style={{ padding: '4px' }}>{""}</td>
                                </tr>
                              )
                            )
                        }
                        
                    </tbody>
                </table>

                <form style={{ marginTop: '20px' }} action="" method="post" onSubmit={(e) => e.preventDefault()}>
                    <div style={{ width: '100%', display: 'flex' }}>
                        <div style={{ width: '25%', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <label>Designation <span style={{ color: 'red' }}> *</span></label>
                        <input  type="text" name="designation" required style={{ width: '90%', padding: '5px 7px' }} value={designation}
                          onChange={(e) => setDesignation(e.target.value)}/>
                        </div>
                        <div style={{ width: '25%', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <label>Father's Name <span style={{ color: 'red' }}> *</span></label>
                        <input  type="text" name="fatherName" required style={{ width: '90%', padding: '5px 7px' }} value={fatherName}
                        onChange={(e) => setFatherName(e.target.value)}/>
                        </div>
                        <div style={{ width: '25%', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <label>Address <span style={{ color: 'red' }}> *</span></label>
                        <input  type="text" name="address" required style={{ width: '90%', padding: '5px 7px' }} value={address}
                        onChange={(e) => setAddress(e.target.value)} />
                        </div>
                        <div style={{ width: '25%', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <label>Place <span style={{ color: 'red' }}> *</span></label>
                        <input  type="text" name="place" required style={{ width: '90%', padding: '5px 7px' }} value={place}
                        onChange={(e) => setPlace(e.target.value)}/>
                        </div>
                    </div>

                    <div style={{ marginTop: '15px' }}>
                        <label>
                            <input 
                            type="checkbox"
                            checked={isChecked}
                            onChange={(e) => setIsChecked(e.target.checked)}
                            required
                            />
                        { } I, {empName}, son/daughter of {fatherName} do hereby declare the above information complete and correct.<span style={{ color: 'red' }}> *</span>
                        </label>
                    </div>

                    
                    <div className="no-print" style={{ marginTop: '15px', textAlign: 'end' }}>
                    <div style={{ marginTop: '15px', textAlign: 'end' }}>
                        {/* <input type="button" value="Back" style={{ padding: '5px 15px', backgroundColor: '#B7B4B1', border: '1px solid #B7B4B1', color: '#fff', marginRight: '15px' }} /> */}
                        <input onClick={async()=>await generatePDF()} type="button" value="Submit" style={{ padding: '5px 15px', backgroundColor: '#538234', border: '1px solid #538234', color: '#fff' }} />
                    </div>
                    </div>
                </form>   
            
            </body>
            </div>
        </html>
        
    </>
  )
}

export default Form12bb
